import React from 'react';
import '../identidad/SidebarMenu.css'; 

import { FaHome } from 'react-icons/fa'; 
import { IoIosAddCircle } from "react-icons/io";
import { IoSettingsSharp } from "react-icons/io5";

const SidebarMenu = ({ isOpen, toggleMenu }) => {
    return (
        <div className={`Sidebar-menu ${isOpen ? 'open' : ''}`}>
            <button className="close-btn" onClick={toggleMenu}>×</button>
            <ul className="menu-list">

                {localStorage.getItem('rol')==="finanzas" && (
                    <a onClick={toggleMenu} href="/DashboardFinanzas" className="menu-item">
                        <FaHome className="menu-icon" />
                        <span className="menu-text">Inicio</span>
                    </a>
                )}

                {localStorage.getItem('rol')==="coordinador" && (
                    <a onClick={toggleMenu} href="/DashboardCoordinador" className="menu-item">
                        <FaHome className="menu-icon" />
                        <span className="menu-text">Inicio</span>
                    </a>
                )}

                {localStorage.getItem('rol')==="soporte" && (
                    <a onClick={toggleMenu} href="/DashboardSoporte" className="menu-item">
                        <FaHome className="menu-icon" />
                        <span className="menu-text">Inicio</span>
                    </a>
                )}

                {localStorage.getItem('rol')==="comunicacion" && (
                    <a onClick={toggleMenu} href="/DashboardComunicacion" className="menu-item">
                        <FaHome className="menu-icon" />
                        <span className="menu-text">Inicio</span>
                    </a>
                )}

                {(localStorage.getItem('rol') === "coordinador" || localStorage.getItem('rol') === "finanzas") && (
                    <a onClick={toggleMenu} href="/FormularioAdelanto" className="menu-item">
                        <IoIosAddCircle className="menu-icon" />
                        <span className="menu-text">Adelanto</span>
                    </a>
                )}

                {(localStorage.getItem('rol') === "coordinador" || localStorage.getItem('rol') === "finanzas") && (
                    <a onClick={toggleMenu} href="/FormCajaChica" className="menu-item">
                        <IoIosAddCircle className="menu-icon" />
                        <span className="menu-text">Formulario Caja Chica</span>
                    </a>
                )}

                {localStorage.getItem('rol')==="coordinador" && (
                    <a onClick={toggleMenu} href="/AgregarPedido" className="menu-item">
                        <IoIosAddCircle className="menu-icon" />
                        <span className="menu-text">Pedido Comunicación</span>
                    </a>
                )}
            </ul>
        </div>
    );
};

export default SidebarMenu;
